export default {
  wipe(){

    const CRMAgentU = localStorage.getItem('CRMAgent_u');
    const CRMAgentP = localStorage.getItem('CRMAgent_p');
    const privacyWarning = localStorage.getItem('privacyWarning');
    localStorage.clear();
    if (CRMAgentU != null) localStorage.setItem('CRMAgent_u', CRMAgentU);
    if (CRMAgentP != null) localStorage.setItem('CRMAgent_p', CRMAgentP);
    if (privacyWarning != null) localStorage.setItem('privacyWarning', privacyWarning);
  },

  getCRMUserCredentials(){
    return {
      'CRMAccountID': localStorage.getItem('CRMAccountID'),
      'CRMAgentID': localStorage.getItem('CRMAgentID')
    };
  },

  setItem (localStorageMainKey, localStorageSpecificKey, localStorageContentKey, localStorageValue) {
    const localStorageContent = localStorage.getItem(localStorageMainKey) ? JSON.parse(localStorage.getItem(localStorageMainKey)) : {};
    if (!localStorageContent[localStorageSpecificKey]){
      localStorageContent[localStorageSpecificKey] = {};
    }
    localStorageContent[localStorageSpecificKey][localStorageContentKey] = localStorageValue;
    localStorage.setItem(localStorageMainKey, JSON.stringify(localStorageContent));
  },

  getItem (localStorageMainKey, localStorageSpecificKey, localStorageContentKey) {
    const localStorageContent = localStorage.getItem(localStorageMainKey) ? JSON.parse(localStorage.getItem(localStorageMainKey)) : {};
    if (!localStorageContent[localStorageSpecificKey]){
      localStorageContent[localStorageSpecificKey] = {};
    }
    return localStorageContent[localStorageSpecificKey][localStorageContentKey];
  },

  clearSpecificKey (localStorageMainKey, localStorageSpecificKey) {
    const localStorageContent = localStorage.getItem(localStorageMainKey) ? JSON.parse(localStorage.getItem(localStorageMainKey)) : {};
    if (localStorageContent && localStorageContent[localStorageSpecificKey]){
      delete localStorageContent[localStorageSpecificKey];
      localStorage.setItem(localStorageMainKey, JSON.stringify(localStorageContent));
    }
  },

  setSingleItem (localStorageMainKey, localStorageValue) {
    localStorage.setItem(localStorageMainKey, localStorageValue);
  },

  getSingleItem (localStorageMainKey) {
    return localStorage.getItem(localStorageMainKey);
  },

}